import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import { UserProvider } from './UserContext';
import { AuthProvider } from './AuthContext'; // Ensure this is the correct import
import { SubscriptionProvider } from './SubscriptionContext';

import App from './App';

ReactDOM.render(
    <Router>
        <UserProvider>
            <AuthProvider>
			<SubscriptionProvider>
                <App />
				</SubscriptionProvider>
            </AuthProvider>
        </UserProvider>
    </Router>,
    document.getElementById('root2')
);
